import styled from "styled-components";

export const CustomListGroupItem = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  gap: 20px;
  text-align: center;
`;

export const CustomToolBarGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  right: ${({ right }) => right || 0};
  left: ${({ left }) => left || 0};
  padding: ${({ padding }) => padding || "10px"};
`;

export const FormContainer = styled.div`
  background-color: rgb(219, 41, 41);
`;

export const ChatMessage = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;

  background: #f7f7f7;
  border-radius: 8px;
`;

export const CustomTextArea = styled.textarea`
  width: 100%;
  font-family: "Nunito";
  border-radius: 8px;
  padding: 10px;
  border: 1px solid var(--secondary);
  background: #fff;
  &::placeholder {
    color: var(--gray-dark);
    font-size: 14px;
  }
`;
